import { cn } from "@/lib/cn";
import { STATUS } from "@/lib/status";
import { LiveDot } from "@/components/live-dot";
import type { RunStatus } from "@/api/types";

export function StatusBadge({ status, className }: { status: RunStatus; className?: string }) {
  const s = STATUS[status];
  return (
    <span
      className={cn(
        "inline-flex items-center gap-1.5 rounded-full px-2 py-0.5 text-xs font-medium capitalize",
        s.badge,
        className,
      )}
    >
      <LiveDot color={s.color} live={s.live} size={6} />
      {s.label}
    </span>
  );
}
